import {
  ref, reactive, Ref, onMounted,
} from 'vue';
import backToTeacherHome from '@/lib/backToTeacherHome';
import { Router } from 'vue-router';
import { ManagementFrameTitleItem } from '@/components/ui/managementFrame/js/types';
import CommonStore from '@/store/common/index';
import { Teacher } from './teacherModule';
import { Class } from './classModule';

const titleListBase: ManagementFrameTitleItem[] = [
  { name: '班级列表' },
  { name: '教师列表' },
];

const teacherTitleListBase = [titleListBase[0]];

export default (router: Router, classPlusClick: Function, teacherPlusClick: Function, teacherModule: Teacher, classMemberPlusClick: Function, classModule: Class) => {
  const showSearchIcon = ref(true); // 搜索按钮显示状态

  const titleList = reactive(CommonStore.getState().role === 'admin' ? titleListBase : teacherTitleListBase);

  const handleBackClick = (showValidate: Ref<boolean>) => {
    if (showValidate.value) showValidate.value = false;
    else { backToTeacherHome(router); }
  };

  const handlePlusClick = async (studentValidate: boolean) => {
    if (studentValidate) {
      classMemberPlusClick();
    } else if (showSearchIcon.value) {
      classPlusClick();
    } else {
      teacherPlusClick();
    }
  };

  const handleSearchClick = () => {
    console.log('searchIcon has clicked');
  };

  const handleTagClick = async (index: number) => {
    // if (teacherModule.list.length === 0) {
    //   await teacherModule.query({ pageNo: 1, pageSize: 12 });
    // }
    const str = titleListBase[index].name;
    if (str === '班级列表') {
      await classModule.query({ pageNo: 1, pageSize: 12 });
    }
    if (str === '教师列表') {
      await teacherModule.query({ pageNo: 1, pageSize: 12 });
    }
    showSearchIcon.value = index === 0;
  };
  const getDefaultPassword = () => {
    teacherModule.getDefaultPasswordValue();
  };
  onMounted(() => (
    // eslint-disable-next-line no-sequences
    getDefaultPassword(),
    handleTagClick(0)
  ));

  return {
    showSearchIcon,
    titleList,
    handleBackClick,
    handlePlusClick,
    handleSearchClick,
    handleTagClick,
    getDefaultPassword,
  };
};
